<div *transloco="let t" class="col {{itemClass}} grid-item">
  <app-ribbon [isOpened]="!!eventItem?.open">
    {{ !!eventItem?.open ? t('race.grid.registration.opened') : t('race.grid.registration.closed') }}
  </app-ribbon>

  <!--  TODO REGISTERED OR PARTICIPATED -->
  <!--  <app-ribbon [isOpened]="!!eventItem?.open" [ribbonClass]="'bottom'">-->
  <!--    PARTICIPATED-->
  <!--  </app-ribbon>-->
  <div class="content-box">
    <div class="logo-placeholder">
      @if(eventItem?.imageMedium !== null){
        <img class="d-block logo" src="{{eventItem!.imageMedium}}" alt="">
      }
    </div>
    <p class="pb-2 fw-bold fs-5 line-height-12">{{ eventItem?.name ?? '' }}</p>
    <div class="d-flex">
      <div class="d-flex flex-column">
        <p class="pe-2">{{ t('race.grid.start') }}</p>
        <p>{{
            eventItem ? (eventItem.start | localizedDate:'short')
              : '17.12.2022. 09:30'
          }}</p>
      </div>
      <div class="separator"></div>
      <div class="d-flex flex-column">
        <p class="pe-2">{{ t('race.grid.end') }}</p>
        <p>{{
            eventItem ? (eventItem.end | localizedDate:'short') :
              '17.12.2022. 13:00'
          }}</p>
      </div>
    </div>
  </div>
</div>
